export function CalendarRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <title>C a l e n d a r R i g h t</title>
      <path
        d="M15.5 11.2L9.8 5.6C9.4 5.2 8.8 5.2 8.4 5.6C8 6 8 6.6 8.4 7L13.3 12L8.4 17C8 17.4 8 18 8.4 18.4C8.6 18.6 8.8 18.7 9.1 18.7C9.4 18.7 9.6 18.6 9.8 18.4L15.5 12.8C15.9 12.3 15.9 11.7 15.5 11.2C15.5 11.3 15.5 11.3 15.5 11.2Z"
        fill="#252525"
      />
    </svg>
  );
}
